var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var TagOption = createReactClass({
    mixins: [PureRenderMixin],

    handleTagOptionChange: function(){
        this.props.onTagOptionChange(this.props.tag);
    },

    render: function(){
        var tagName = this.props.tag.name;
        var filterText = this.props.filterText;
        var tagNameWithFilterMark = tagName.replace(new RegExp(filterText, 'i'), '<b>$&</b>');

        return (
            <li onClick={this.handleTagOptionChange}><span className="ion-plus-circled"></span><span dangerouslySetInnerHTML={{__html: tagNameWithFilterMark}}></span></li>
        );
    }
});

module.exports = TagOption;



// WEBPACK FOOTER //
// ./src/common/routes/message-center/components/layout/tagOption.jsx